<div class="leftbar__tabs-content" appLeftbarContent
     [isLeftbarOpen]="isLeftbarOpen"
     [shouldShowSettingsMenu]="shouldShowSettingsMenu()">
</div>
<router-outlet></router-outlet>
